import { AlphaNIcon } from './AlphaNIcon';

/**
 * author: GreenTurtwig
 * id 528E55D8-A774-4678-9D76-42EEFDF5FE3E
 * name alpha-n
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-n.svg
 * tags
 * - Automotive 
 * - Alpha / Numeric 
 */
export const LetterNIcon = AlphaNIcon;
export default LetterNIcon